module.exports = __webpack_public_path__ + "static/img/gallery_1.9729a12.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer4/gallery_1.png
// module id = 3sL2
// module chunks = 1